export const administrationAccountsSiteLocationRscAssistantDetails = {
    template: require('./administration-accounts-site-location-rsc-assistant-details.html'),
    controller: 'AdministrationAccountsSiteLocationRscAssistantDetailsController'
};
